<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >

    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-upload"
            font-scale="4"
        />
        <div class="mb-3">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>

  <b-card
    title="مدیریت سگمنت های سفارشی"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  variant="primary"
                  class="mb-1 mr-auto ml-1"
                  :to="{ name: 'customSegment'}"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      autocomplete="off"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="archiveStatus"
                >
                  <v-select
                      id="archiveStatus"
                      v-model="filterOptions.IsArchive"
                      dir="rtl"
                      :reduce="x => x.value"
                      label="text"
                      input-id="archiveStatus"
                      :clearable="true"
                      :options="enums('archive')"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'customSegment', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
         <b-dropdown
             right
             variant="link"
             class="segmnet-action"
                  toggle-class="text-decoration-none"
                  no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body"
                  />
                </template>
                <b-dropdown-item>
                  <b-link :to="{ name: 'sendNotification', params: {messageId:'new',customSegmentId:data.item.Id }}">
                    <feather-icon
                        icon="MailIcon"
                        class="mr-50"
                        size="16"
                    />
                  </b-link>
                  <span>ارسال پیام</span>
                </b-dropdown-item>
                <b-dropdown-item @click="exportExcel(data.item.Id)">
                  <feather-icon
                      icon="FileTextIcon"
                      class="mr-50"
                  />
                  <span>خروجی اکسل</span>
                </b-dropdown-item>
                <b-dropdown-item @click="archive(!data.item.IsArchive, data)">
                  <feather-icon
                      icon="ArchiveIcon"
                      class="mr-50"
                      @click="archive(true, data)"
                  />
                  <span v-if="data.item.IsArchive">فعال کردن</span>
                  <span v-else>غیرفعال کردن</span>
                </b-dropdown-item>
                <b-dropdown-item @click="remove(data.item.Id)">
                  <feather-icon
                      icon="TrashIcon"
                      class="mr-50"
                  />
                  <span>حذف</span>
                </b-dropdown-item>
              </b-dropdown>

              <b-link :to="{ name: 'customSegment', params: { id: data.item.Id }}">
                <feather-icon
                  icon="EditIcon"
                  size="16"
                  class="ml-1"
                />
              </b-link>

              <b-spinner
                  v-if="data.item.getSampleUserLoading"
                  class="ml-1 spinner-vertical"
                  small
                  variant="secondary"
              />
              <feather-icon
                  v-else
                  class="ml-1"
                  :icon="data.detailsShowing ? 'EyeOffIcon' : 'EyeIcon'"
                  size="16"
                  @click="getSampleUser(data)"
              />
            </div>
          </template>
          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
          <template #row-details="row">
            <div>
              تعداد کل کاربران
              :
              <b-badge variant="light-info">
                {{ row.item.sampleUser.UserCount }}
              </b-badge>
            </div>
            <div class="mt-1">
              کاربران نمونه
              :
            </div>
            <b-row
              align-content="start"
              align-h="start"
            >
              <template v-for="user in row.item.sampleUser.Example">
                <b-col
                  align-self="start"
                  cols="2"
                  lg="auto"
                  class="mt-1"
                >
                  <b-link
                    :to="{ name: 'userDetail', params: { id: user.Id }}"
                    target="_blank"
                  >
                    <b-badge variant="light-info">
                      {{ user.Id }}
                    </b-badge>
                  </b-link>
                </b-col>
              </template>
            </b-row>
          </template>
        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>
  </b-card>

  </b-overlay>
</template>
<script>
import { BIcon, BIconArchiveFill, BIconArchive } from 'bootstrap-vue'

export default {
  name: 'Segment',
  components: { BIcon, BIconArchiveFill, BIconArchive },
  data() {
    return {
      filterOptions: {
        PerPage: 10,
        Page: 1,
        Title: null,
        IsArchive: false,
      },
      totalRows: 1000 * 1000,
      loading: false,
      processing: false,
      counter: 1,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Description',
          label: 'توضیحات',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    archive(archive, row) {
      this.$http.post(this.$api.segmentCustom.setArchive, {
        Id: row.item.Id,
        IsArchive: archive,
      }).then(() => { this.update() })
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.segmentCustom.getlist, this.filterOptions)
        .then(response => {
          this.loading = false
          this.items = response.data
          this.items = this.items.map(item => {
            this.$set(item, 'sampleUser', { } )
            this.$set(item, 'getSampleUserLoading', false)
            return item
          })
          this.totalRows = response.totalRow
        })
    },
    remove(id) {
      this.removeRow(this.$api.segmentCustom.remove, 'Id', id)
    },
    exportExcel(id){

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = id + '.xlsx'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      xmlHttpRequest.open("POST", '/api/segment/export-excel')
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify({
        'Id': id
      }))
    },
    getSampleUser(row) {
      if (row.detailsShowing === false) {
      row.item.getSampleUserLoading = true
      this.$http.post(this.$api.segmentCustom.getSampleUser, { Id: row.item.Id })
          .then(response => {
            row.item.sampleUser = response.data
            row.item.getSampleUserLoading = false
            row.toggleDetails()
          })
    } else {
        row.toggleDetails()
      }
    },
  },
}
</script>
